export const setLocalStorageItem = (keyName, value) => {
  window.localStorage.setItem(keyName, value);
};

export const getLocalStorageItem = (keyName) => {
  return window.localStorage.getItem(keyName);
};

export const removeLocalStorageItem = (keyName) => {
  window.localStorage.removeItem(keyName);
};

export const setSessionStorageItem = (keyName, value) => {
  window.sessionStorage?.setItem(keyName, value);
};

export const getSessionStorageItem = (keyName) => {
  return window.sessionStorage?.getItem(keyName);
};

export const removeSessionStorageItem = (keyName) => {
  window.sessionStorage?.removeItem(keyName);
};